import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "button"]

  connect() {
    this._close = (e) => { if (!this.element.contains(e.target)) this.close() }
    document.addEventListener("click", this._close)
  }

  disconnect() {
    document.removeEventListener("click", this._close)
  }

  toggle(event) {
    event.stopPropagation()
    const hidden = this.menuTarget.classList.toggle("hidden")
    this._setExpanded(!hidden)
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this._setExpanded(false)
  }

  _setExpanded(expanded) {
    if (this.hasButtonTarget) this.buttonTarget.setAttribute("aria-expanded", String(expanded))
  }
}
